import { render, staticRenderFns } from "./text-header-new.vue?vue&type=template&id=4af774c2&"
import script from "./text-header-new.vue?vue&type=script&lang=js&"
export * from "./text-header-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af774c2')) {
      api.createRecord('4af774c2', component.options)
    } else {
      api.reload('4af774c2', component.options)
    }
    module.hot.accept("./text-header-new.vue?vue&type=template&id=4af774c2&", function () {
      api.rerender('4af774c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-header-new.vue"
export default component.exports